import {
  CheckinsOption,
  InboxOption,
  ScheduledOption,
  SentOption,
} from "contexts/OutreachContacts";
import { Map } from "schemas/functions";

export enum Page {
  RECOMMENDATIONS = "recommendations",
  BRANDS = "brands",
  HOME = "home",
  INBOX = "inbox",
  TRACKING = "tracking",
  CAMPAIGNS = "campaigns",
  LOCAL = "local",
  VA = "virtual-assistant",
  TEMPLATES = "templates",
  SETTINGS = "settings",
  PROFILE = "profile",
  BENTO_GUIDE = "bento",
}

export const PageMenu: Map = {
  [Page.RECOMMENDATIONS]: {
    label: "Recommendations",
    icon: "fa-solid fa-star",
  },
  [Page.HOME]: {
    label: "Home",
    icon: "fa-solid fa-home",
  },
  [Page.BRANDS]: {
    label: "Brands",
    icon: "fa-solid fa-search",
  },
  [Page.INBOX]: {
    label: "Inbox",
    icon: "fa-solid fa-envelope",
    children: [ScheduledOption, SentOption, InboxOption, CheckinsOption],
  },

  [Page.TRACKING]: {
    label: "Tracking",
    icon: "fa-solid fa-square-kanban",
  },
  [Page.CAMPAIGNS]: {
    label: "Campaigns",
    icon: "fa-solid fa-chart-simple-horizontal",
  },
  [Page.LOCAL]: {
    label: "Pitch Local",
    icon: "fa-solid fa-location-dot",
  },
  [Page.VA]: {
    label: "VA",
    icon: "fa-solid fa-bolt",
  },
  [Page.TEMPLATES]: {
    label: "Templates",
    icon: "fa-solid fa-file-pen",
  },
  [Page.SETTINGS]: {
    label: "Settings",
    icon: "fa-regular fa-gear",
  },
  [Page.PROFILE]: {
    label: "Profile",
    icon: "fa-solid fa-user",
  },
  [Page.BENTO_GUIDE]: {
    label: "How to Use Bento",
    icon: "fa-regular fa-wrench",
  },
};
